import { render } from "./SunIcon.vue?vue&type=template&id=da1987a6"
const script = {}
script.render = render

export default script